<div class="lib-dialog">
    <h2 mat-dialog-title [id]="titleId" class="lib-dialog__title heading-3">{{ data.title }}</h2>

    <mat-dialog-content class="lib-dialog__content">
        <p [id]="messageId" class="lib-dialog__message body-0">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="lib-dialog__actions">
        @if (data.secondaryLabel) {
            <button mat-stroked-button class="lib-dialog__cta" type="button" (click)="onSecondaryClick()">
                <span class="primary-cta">{{ data.secondaryLabel }}</span>
            </button>
        }
        <button mat-raised-button class="lib-dialog__cta" cdkFocusInitial type="button" (click)="onPrimaryClick()">
            <span class="primary-cta">{{ data.primaryLabel }}</span>
        </button>
    </mat-dialog-actions>
</div>
